import { api } from "./client";

/**
 * Един ред от справка „Променени цени" — продукт ИЛИ негова добавка.
 *
 * Паричните и количествените полета са `Decimal` в BE-то и идват като JSON
 * НИЗОВЕ (`docs/cross-repo-contract.md`) — затова са низове и тук. Парсват се
 * веднъж, при строенето на реда (`priceChanges/priceChangesMath.ts`), през
 * `parseDecimal`; никоя клетка не смята върху суровата стойност.
 */
export interface PriceChangeReportItem {
  row_key: string;
  kind: "product" | "addition";
  addition_id: number | null;

  bill_id: number;
  bill_name: string;
  bill_status: string;
  bill_closed_at: string | null;
  bill_element_item_id: number;

  /** Моментът на смяната — по него се филтрира периодът. */
  changed_at: string;
  ordered_at: string | null;
  user_id: number | null;
  user_name: string | null;

  item_id: number;
  item_name: string;
  quantity: string;
  old_price: string;
  new_price: string;
  /** Знаков процент: > 0 = поевтиняване, < 0 = поскъпване. */
  percent: string;
  /** Знакова разлика: нова − стара (на единица) и × количеството. */
  difference: string;
  line_difference: string;

  is_active: boolean;
  reverted_at: string | null;
  reverted_by_id: number | null;
  reverted_by_name: string | null;

  restaurant_id: number | null;
  restaurant_name: string | null;
}

export interface PriceChangeReportResponse {
  items: PriceChangeReportItem[];
  total: number;
}

export interface PriceChangeReportFilters {
  start_date?: string;
  end_date?: string;
  /** Филтърът „смяна" (`lib/reportShift.ts`); без него — всички смени. */
  shift?: number;
}

export const getPriceChangesReport = async (
  filters?: PriceChangeReportFilters,
): Promise<PriceChangeReportItem[]> => {
  const params = new URLSearchParams();
  if (filters?.start_date) params.append("start_date", filters.start_date);
  if (filters?.end_date) params.append("end_date", filters.end_date);
  if (filters?.shift) params.append("shift", String(filters.shift));

  const response = await api.get<PriceChangeReportResponse>(
    `/reports/analytics/price-changes${
      params.toString() ? `?${params.toString()}` : ""
    }`,
  );
  return response.data.items;
};
